"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getSuiteAppProps = void 0;

var _react = require("@fluentui/react");

var _getUrlForApp = require("../environment/getUrlForApp");

var getSuiteAppProps = (0, _react.memoizeFunction)(function (appKey, enabledApps, t) {
  var suiteApps = [];

  if (appKey !== _getUrlForApp.AppKeys.apps && enabledApps[_getUrlForApp.AppKeys.apps]) {
    suiteApps.push({
      key: _getUrlForApp.AppKeys.apps,
      name: t('My Apps'),
      iconProps: {
        iconName: 'rocket'
      },
      href: (0, _getUrlForApp.getUrlForApp)(location, _getUrlForApp.AppKeys.apps).toString(),
      target: '_blank'
    });
  }

  if (appKey !== _getUrlForApp.AppKeys.groups && enabledApps[_getUrlForApp.AppKeys.groups]) {
    suiteApps.push({
      key: _getUrlForApp.AppKeys.groups,
      name: t('My Groups'),
      iconProps: {
        iconName: 'Group'
      },
      href: (0, _getUrlForApp.getUrlForApp)(location, _getUrlForApp.AppKeys.groups).toString(),
      target: '_blank'
    });
  }

  return suiteApps;
});
exports.getSuiteAppProps = getSuiteAppProps;